export default __webpack_public_path__ + "static/media/repo_icon.1a3fac80.svg";